import { topicIndex } from '@/mocks/exposure';
import { SectionHead } from './ui';

const barTone: Record<string, string> = {
  primary: 'bg-primary-500',
  secondary: 'bg-secondary-400',
  accent: 'bg-accent-500',
};

export default function IndexSection() {
  return (
    <section id="index" className="mx-auto w-full max-w-[1280px] px-4 py-9 md:px-6 md:py-14">
      <SectionHead
        no="05"
        title="大合集索引"
        sub="按人物与事件归集的一站式查证目录，最醒目入口"
        more="更多主题合集"
        href="#"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {topicIndex.map((t) => (
          <a
            key={t.key}
            href="#"
            className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:-translate-y-0.5 hover:border-background-300"
          >
            <div className={`h-1.5 w-full ${barTone[t.tone]}`} />
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <span className="font-serif text-3xl font-black leading-none text-secondary-200">
                {t.key}
              </span>
              <h3 className="mt-3 flex items-center justify-between font-serif text-lg font-black text-foreground-900 group-hover:text-primary-700">
                {t.title}
                <i className="ri-arrow-right-up-line text-base text-foreground-300 transition group-hover:text-primary-500" />
              </h3>
              <ul className="mt-3 flex flex-1 flex-col gap-2">
                {t.items.map((it, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                    <span className="h-1 w-1 shrink-0 rounded-full bg-primary-400" />
                    <span className="truncate">{it}</span>
                  </li>
                ))}
              </ul>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-foreground-500">
                <i className="ri-folders-line" /> {t.count}
                <i className="ri-arrow-right-s-line transition group-hover:translate-x-0.5" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}